export const GET_WINTER_CAMPS_2027_FROM_CHILD = /* GraphQL */ `
  query getWinterCamps2027FromChild {
    me {
      id
      children {
        id
        name
        surname
        winter2027: availableProducts(
          category: "Zima 2027"
          period: { start: "2027-01-01", end: "2027-12-31" }
        ) {
          ... on IProduct {
            sku
            name
            stock {
              available
            }
            price {
              value
            }
          }
        }
      }
    }
  }
`;

export const ADD_WINTER_CAMPS_2027_TO_CART = /* GraphQL */ `
  mutation AddToCartWinterCamp2027($sku: ID!, $childId: ID!) {
    cartAddItem(sku: $sku, childId: $childId) {
      id
      problems {
        ... on ICartProblem {
          code
          message
        }
        ... on CartProblemCustomData {
          item {
            ... on ICartItem {
              id
              sku
            }
          }
          property
        }
      }
      items {
        ... on CartItemNewWinterCamp {
          sku
          id
        }
      }
    }
  }
`;
